<template>
  <div class="new-main-footer-revamp__item__social-media">
    <a href="/">
      <img
        id="logo-footer"
        :src="footerLogo"
        alt="lion-parcel-logo-footer"
        height="40"
        width="170"
        style="cursor: pointer;"
        @click="$router.push('/')"
      >
    </a>
    <div class="new-main-footer-revamp__item__social-media__link">
      <a
        v-for="sm in socialMedia"
        ref="media-icon"
        :key="sm.link"
        style="cursor: pointer;"
        :href="sm.link"
        rel="noreferrer noopener"
        target="_blank"
      >
        <img
          id="social-media-icon"
          :src="sm.icon"
          :alt="sm.alt"
          :title="sm.title"
          height="36"
          width="36"
        >
      </a>
    </div>
  </div>
</template>

<script>
import SmTwitter from "@/assets/sm_twitter.svg"
import SmFB from "@/assets/sm_facebook.svg"
import SmIG from "@/assets/sm_insta.svg"
import SmYoutube from "@/assets/sm_youtube.svg"
import SmLinkedin from "@/assets/sm_linkedin.svg"
import SmTikTok from "@/assets/sm_tiktok.svg"
import mixinMobile from "@/misc/mixinMobile"
import footerLogo from "@/assets/lp_logo_footer_new.svg"

export default {
  name: "SocialMedia",
  mixins: [mixinMobile],
  data() {
    return {
      footerLogo,
      socialMedia: [
        {
          icon: SmIG,
          alt: "instagram",
          title: "Instagram",
          link: "https://www.instagram.com/lionparcelid/?hl=id"
        },
        {
          icon: SmTwitter,
          alt: "twitter",
          title: "Twitter",
          link: "https://twitter.com/lionparcel_"
        },
        {
          icon: SmFB,
          alt: "facebook",
          title: "Facebook",
          link: "https://web.facebook.com/lionparcelid/"
        },
        {
          icon: SmYoutube,
          alt: "youtube",
          title: "YouTube",
          link: "https://www.youtube.com/channel/UCFpSdUfuyHJPsiIE99mCnyg/featured"
        },
        {
          icon: SmLinkedin,
          alt: "linkedin",
          title: "LinkedIn",
          link: "https://id.linkedin.com/company/lion-parcel"
        },
        {
          icon: SmTikTok,
          alt: "tiktok",
          title: "TikTok",
          link: "https://www.tiktok.com/@lionparcelid?lang=en"
        },
      ]
    }
  },
  methods: {}
}
</script>
